import GLOBAL from './GLOBAL';

const win = GLOBAL.getWindow();

const runLaterOrIdle = (fn) => {
  if (win.requestIdleCallback) {
    win.requestIdleCallback(fn, { timeout: 10000 });
  }
  setTimeout(fn, 10000);
};

export default runLaterOrIdle;
